module.exports = __webpack_public_path__ + "img/arrow.b191fd3a.svg";